import React from "react";
export const shortArrowIcon = ({ fill = "#99cad1", height = 23, width = 24 }) => (React.createElement("svg", { width: width, height: height, viewBox: "0 0 24 24", fill: fill, xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("g", { clipPath: "url(#6cv15a3sra)" },
        React.createElement("path", { d: "m16.172 11-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2h12.172z", fill: "inherit" })),
    React.createElement("defs", null,
        React.createElement("clipPath", null,
            React.createElement("path", { fill: fill, d: "M0 0h24v24H0z" })))));
